import React, { useState, useEffect } from 'react'
import { Paper, FormControl, TextField, Grid, Button } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { userService } from '../../services/user.service'
import serviceService from '../../services/service.service'

const useStyles = makeStyles(theme => ({
    paper: {
        padding: theme.spacing(3),
    },
    loadingSection: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '300px',
        width: '100%',
    },
}))

const Details = () => {
    const classes = useStyles()
    const [serviceDetails, setServiceDetails] = useState()
    const [isLoadingData, setIsLoadingData] = useState(true)

    useEffect(() => {
        const managedService = userService.getManagedService()

        ;(async function getServiceAsync() {
            try {
                await serviceService
                    .getService(managedService.id)
                    .then(result => {
                        setServiceDetails(result)
                        setIsLoadingData(false)
                    })
            } catch (exception) {
                console.log(exception)
            }
        })()
    }, [])

    return (
        <>
            {isLoadingData ? (
                <>Loading....</>
            ) : (
                <Paper className={classes.paper}>
                    <Grid
                        container
                        direction='row'
                        justify='flex-start'
                        alignItems='flex-start'
                        spacing={3}>
                        <Grid item xs={4}>
                            <FormControl>
                                <TextField
                                    label={'Client Name'}
                                    value={serviceDetails.clientName}
                                    disabled
                                    onChange={e => {
                                        const val = e.target.value
                                        setServiceDetails({
                                            ...serviceDetails,
                                            serviceName: val,
                                        })
                                    }}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={4}>
                            <FormControl>
                                <TextField
                                    label={'Service Name'}
                                    value={serviceDetails.serviceName}
                                    disabled
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={4}>
                            <FormControl>
                                <TextField
                                    label={'Legacy Service Id'}
                                    value={serviceDetails.legacyServiceId}
                                    disabled
                                />
                            </FormControl>
                        </Grid>
                    </Grid>

                    <Grid
                        container
                        direction='row'
                        justify='flex-start'
                        alignItems='flex-start'
                        spacing={3}>
                        <Grid item xs={4}>
                            <FormControl>
                                <TextField
                                    label={'Process Engine Service Id'}
                                    value={
                                        serviceDetails.processEngineServiceId
                                    }
                                    onChange={e => {
                                        const val = e.target.value
                                        setServiceDetails({
                                            ...serviceDetails,
                                            employeeNumberLabel: val,
                                        })
                                    }}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={4}>
                            <FormControl>
                                <TextField
                                    label={'Client Dataset Name'}
                                    value={serviceDetails.datasetName}
                                    disabled
                                    onChange={e => {
                                        const val = e.target.value
                                        setServiceDetails({
                                            ...serviceDetails,
                                            emailDomain: val,
                                        })
                                    }}
                                />
                            </FormControl>
                        </Grid>

                        <Grid item xs={4}>
                            <FormControl>
                                <TextField
                                    label={'Username Prefix'}
                                    value={serviceDetails.usernamePrefix}
                                    disabled
                                />
                            </FormControl>
                        </Grid>

                        <Grid
                            container
                            item
                            xs={6}
                            direction='row'
                            justify='flex-start'>
                            <Button variant='contained' color='secondary'>
                                Update
                            </Button>
                        </Grid>
                    </Grid>
                </Paper>
            )}
        </>
    )
}

export default Details
